import { PlatformSource } from '@/api/types/common.types';
import { DeviceType } from '@/utils/getDeviceType';

export const getPlatformSource = (deviceType: DeviceType) => {
  switch (deviceType) {
    case DeviceType.Mobile:
      return PlatformSource.Mobile;
    default:
      return PlatformSource.Desktop;
  }
};
